import { useIntl } from 'react-intl';
import Widget from '../../../components/Widget';
import './style.scss';

const TermsOfService = () => {
  const intl = useIntl();

  return (
    <div className="">
      <Widget
        breadcrumbs={[intl.formatMessage({ id: 'adminMenu.termsOfService' })]}
        tabProps={{
          onChange: (key: string) => {},
        }}
        content={
          <div className="terms-of-service">
            <div
              dangerouslySetInnerHTML={{
                __html: `
              <div class="terms-of-service-main">
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title1' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content1' })}</div>
                </div>
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title2' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content2' })}</div>
                </div>
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title3' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content3' })}</div>
                </div>
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title4' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content4' })}</div>
                </div>
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title5' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content5' })}</div>
                </div>
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title6' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content6' })}</div>
                </div>
                <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title7' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content7' })}</div>
                </div>
                      <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title8' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content8' })}</div>
                </div>
                      <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title9' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content9' })}</div>
                </div>
                      <div class="terms-of-service-main-one">
                  <div class="terms-of-service-main-one-title">${intl.formatMessage({ id: 'termsOfService.title10' })}</div>
                  <div class="terms-of-service-main-one-content">${intl.formatMessage({ id: 'termsOfService.content10' })}</div>
                </div>
              </div>
            `,
              }}
            />
          </div>
        }
        title={intl.formatMessage({ id: 'adminMenu.termsOfService' })}
      />
    </div>
  );
};

export default TermsOfService;
